import { UTCDate } from '@date-fns/utc'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import type { DateBuilderReturnType } from '@mui/x-date-pickers/models'
import { parse } from 'date-fns'

/** Keeps date-fns calendar arithmetic and keyboard input in UTC, including during local DST gaps. */
export class AdapterDateFnsUTC extends AdapterDateFns {
    override date = <T extends string | null | undefined>(value?: T): DateBuilderReturnType<T> =>
        (value === null ? null : value === undefined ? new UTCDate() : new UTCDate(value)) as DateBuilderReturnType<T>

    override parse = (value: string, format: string) =>
        // date-fns v3 otherwise converts parsed fields to the system timezone, even with a UTCDate reference.
        value === '' ? null : parse(`${value} Z`, `${format} X`, new UTCDate(), { locale: this.locale })

    override getTimezone = () => 'UTC'

    override setTimezone = (value: Date) => new UTCDate(value)
}
